import { auth } from "../services/firebase"

export const signup = (email, password) => {
    return auth().createUserWithEmailAndPassword(email, password)
}


export const signin = (email, password) => {
    return auth().signInWithEmailAndPassword(email, password)
}

export const signInWithGoogle = () => {
    const provider = new auth.GoogleAuthProvider();
    return auth().signInWithPopup(provider);
}

export const signInWithGitHub = () => {
    const provider = new auth.GithubAuthProvider();
    return auth().signInWithPopup(provider);
}

export const isLoggedIn = () => {
    return !!auth().currentUser
}

export const changeDisplayName = (name) => {
    return auth().currentUser.updateProfile({
        displayName: name
    })
}

export const adminList = [
    "jamie_phan@hotmail.com",
    "test@test.com"
]

export const isAdmin = () => {

    return adminList.includes(auth().currentUser.email.toLowerCase())
}

export const currentUser = () => {
    return auth().currentUser
}

export const logout = () => {
    return auth().signOut()
}